/**
 * Only to be used in WPO optimalisation
 */
